<template>
<div class="chapter">
<div class="inner_page">
<div class="galley-rw">
<section class="frontmatter-rw Chapter-rw" epub:type="frontmatter chapter" id="Chapter1">
<div class="title-block-rw" id="title-block2"> </div>
<p class="firstpara-rw" id="p37"><i>Being alone was something I had always excelled at. As a kid, I kept to myself from the time I started school. I noticed how the other kids seemed to crave company, how they sought out a pack of friends to roll through life with. That wasn’t me; I never needed anyone. Or anything. As I grew up, that feeling of everything being better if I didn’t have to share it followed me wherever I went. I got strong, and smart, and completely self-sufficient. That was the way I liked it.</i></p>
<p id="p38"><i>That was the way it had always been.</i></p>
<p id="p39"><i>Then, one day, I met the pin in the grenade that blew my entire world apart.</i></p>
<p id="p40"><i>And she obliterated my desire for a simple, solitary life. She destroyed my existence, as I knew it.</i></p>
<p id="p41"><i>I was slain by her; where years in the army had failed to demolish my lone spirit, she blew it to smithereens. She owns me.</i></p>
<p id="p42"><i>And I will walk through fire to protect her.</i></p>
</section>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// s005-Chapter-01.vue?013e2c5e